// Modal potwierdzenia wysylki oferty do klienta.
// Pyta czy oprocz zmiany statusu (PUT status=6) handlowiec chce takze przelogowac sie na klienta
// i otworzyc oferte w jego widoku — analogicznie do flow z koszykami (TraderPanelOpenCart).

import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';

interface IProps {
  open: boolean;
  isSending?: boolean;
  onClose: () => void;
  /** Wysyla oferte (PUT status=6) bez przelogowywania. */
  onSendOnly: () => void;
  /** Wysyla oferte i przelogowuje sie na klienta (overlogin + redirect na widok klienta). */
  onSendAndOpen: () => void;
  /**
   * Czy oferta jest typu publicznej akceptacji (EXTERNAL_ACCEPTANCE). Wtedy zamiast
   * przelogowywania klient dostaje link mailem - "Wyslij i otworz" otwiera publiczny URL.
   */
  isExternalAcceptance?: boolean;
}

const SendOfferToClientModal: React.FC<IProps> = ({
  open,
  isSending = false,
  onClose,
  onSendOnly,
  onSendAndOpen,
  isExternalAcceptance = false
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={isSending ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('Wyslij oferte do klienta')}</DialogTitle>
      <DialogContent>
        <p>
          {t(
            'Oferta zostanie wyslana do klienta - status zostanie zmieniony na "Do akceptacji" a klient otrzyma powiadomienie.'
          )}
        </p>
        <p>
          {isExternalAcceptance
            ? t('Mozesz tez przejsc do widoku oferty z linku akceptacyjnego, ktory otrzyma klient.')
            : t('Mozesz takze przelogowac sie na konto klienta i otworzyc oferte w jego widoku, zeby zobaczyc jak to bedzie wygladalo.')}
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSending}>
          {t('Anuluj')}
        </Button>
        <Button onClick={onSendOnly} disabled={isSending}>
          {isSending ? <CircularProgress size={18} /> : t('Tylko wyslij')}
        </Button>
        <Button onClick={onSendAndOpen} variant="contained" color="primary" disabled={isSending}>
          {isSending ? (
            <CircularProgress size={18} />
          ) : isExternalAcceptance ? (
            t('Wyslij i przejdz do oferty')
          ) : (
            t('Wyslij i otworz jako klient')
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendOfferToClientModal;
